module.exports = __webpack_public_path__ + "static/media/cdrv2.4f0994d4.png";